module.exports = __webpack_public_path__ + "static/media/careersNavIcon.bdf309de.svg";